import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { AppNoInfo, AppRemixIcon } from '@/layout/AppComponents';
import AppLink from '../../../routing/helpers/AppLink';
import routes from './moduleQseRoutes';
import BreadcrumbHandler from '../../../layout/components/breadcrumb/BreadcrumbHandler';
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { axiosPath } from "@/routing/helpers/router";
import useIsMounted from "@/layout/components/hooks/useIsMounted";
import { useDispatch } from "react-redux";
import * as currentPageAction from "../../../store/actions/currentPageAction";

const ModuleQseReportHomeScreen = () => {
  const { moduleBridgeHex, subModuleBridgeHex, plantHex } = useParams();
  const [moduleData, setModuleData] = useState(null);
  const isMounted = useIsMounted();
  const dispatch = useDispatch();

  // > LOAD MODULE DATA //
  const loadModuleData = useCallback(async () => {
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_qseReports_getModuleData"),
        { moduleBridgeHex, subModuleBridgeHex, plantHex }
      );
      return response.data;
    } catch (err) {}
  }, []);

  useEffect(() => {
    loadModuleData().then((r) => {
      if (isMounted.current) {
        setModuleData(r);
        dispatch(
          currentPageAction.change("qseReports", {
            hasOmActivities: r.hasOmActivities,
            omActivitiesInitialDate: r.omActivitiesInitialDate,
          })
        );
      }
    });
  }, []);
  // > LOAD MODULE DATA //

  if(!moduleData){
    return <AppNoInfo />
  }

  return (
    <div className="relative m_sr p-3">
      <BreadcrumbHandler
        paths={
          moduleData
            ? [
                {
                  name: `${moduleData.plantName} - Assessment`,
                  route: {
                    name: "user_module_legalCompliance_evaluation",
                    params: {
                      moduleBridgeHex,
                      plantHex,
                      page: 1,
                      filtersHex: 0,
                    },
                  },
                },
                {
                  name: "QHSE Reports",
                },
              ]
            : [{ name: "..." }]
        }
      />
      <div className="row">
        <div className="col-12">
          <h1 className="mb-4">QHSE Reports</h1>
        </div>
      </div>
      <div className="row">
        {moduleData && routes.map((r, index) => {
          return (
            Object.keys(moduleData?.indicators).includes(r.type) && (
              <div key={index} className="col-sm-4">
                <AppLink
                  path={r.routeName}
                  params={{
                    moduleBridgeHex: moduleBridgeHex,
                    subModuleBridgeHex: subModuleBridgeHex,
                    plantHex: plantHex,
                  }}
                  className="card text-decoration-none mb-4"
                >
                  <ReportButton
                    className="card-body text-center pointer text-white"
                    bgColor={r.color}
                  >
                    <AppRemixIcon icon={r.icon} size={30} />
                    <div className="p-2">
                      <h5 className="text-white">{r.title}</h5>
                    </div>
                  </ReportButton>
                </AppLink>
              </div>
            )
          );
        })}
      </div>
    </div>
  );
};

export default ModuleQseReportHomeScreen;

const ReportButton = styled.div`
  background-color: ${(props) => props.bgColor};
`;
